module.exports = __webpack_public_path__ + "static/media/zest.2250e1e9.svg";